import axiosInstance from '../../../core/api/interceptors/axiosInterceptor';

export const getVatRates = async () => {
  const response = await axiosInstance.get('vat/get-vat-rates');
  return response.data;
};

export const getVatRateById = async (id) => {
  const response = await axiosInstance.get(`vat/get-vat-rate/${id}`);
  return response.data;
};

export const addVatRate = async (vatRate) => {
  const response = await axiosInstance.post('vat/add-vat-rate', vatRate);
  return response.data;
};

export const updateVatRate = async (id, vatRate) => {
  const response = await axiosInstance.put(`vat/update-vat-rate/${id}`, vatRate);
  return response.data;
};

export const deleteVatRate = async (id) => {
  await axiosInstance.delete(`vat/delete-vat-rate/${id}`);
};